<template>
  <div>
    <two-integrations :integration1="integration1" :integration2="integration2" :loading="false"/>
    <div class="tile pt-4 my-4">
      <loading-view :loading="initialLoading">
        <h2 class="h4 color_theme px-4">{{ trans('dashboard.integrations.settings.subtitle') }}</h2>
        <div v-if="errors !== null && errors.length > 0" class="mx-4">
          <validation-errors :errors="errors"/>
        </div>
        <form @submit.prevent="saveSettings">
          <div class="m-4">
            <div v-for="category in categories" :key="category.name">
              <expander :title="category.name">
                <template v-slot:content>
                  <form-input-header :description="category.description"></form-input-header>
                  <template v-for="(settings, settingGroup) in getSettingsData(category.name)" :key="settingGroup">
                    <form-input-header :header="settingGroup"></form-input-header>
                    <div
                      :class=" (setting.dependency_settings.length > 0 || setting.is_require_mapping_table) ? 'border px-2 pb-2 rounded-lg mb-1' : ''"
                      v-for="setting in settings" :key="setting.key">
                      <form-input
                        v-model="formData[setting.id].value"
                        :dependencies="setting.dependency_settings"
                        :help-text="setting.description"
                        :label="setting.name"
                        :multiple="setting.is_multiple"
                        :options="setting.application_setting_options"
                        :required="setting.is_required"
                        :setting="setting"
                        :type="setting.field_type_name"
                        :integration-id="integrationId"
                        :application1="integration1"
                        :application2="integration2"
                        :dependency-values="formData"
                        @input-dependency="handleInputDependency"
                      >
                      </form-input>
                    </div>
                  </template>
                </template>
              </expander>
            </div>
            <div class="flex items-center my-6 mr-3 ml-1">
              <div class="ml-auto">
                <form-button
                  v-if="$can('integrations.settings.update')"
                  :value="trans('common.save')"
                  :processing="processingSave"
                  class="mr-6"
                  type="submit"
                  @click.native="saveSettings"
                />
              </div>
            </div>
          </div>
        </form>
      </loading-view>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import DashboardLayout from "@/Layouts/DashboardLayout";
import IntegrationLayout from "@/Layouts/IntegrationLayout";
import HandleSettings from "@/components/mixins/HandleSettings";
import TwoIntegrations from "@/components/Dashboard/TwoIntegrations";
import Expander from "@/components/Dashboard/Expander";
import FormInput from "@/components/Dashboard/FormInput";
import FormInputHeader from "@/components/Dashboard/FormInputHeader";
import MappingTable from "@/components/Dashboard/MappingTable";
import FormButton from "@/components/Shared/Form/Button";
import ValidationErrors from "@/components/Shared/ValidationErrors";

export default {
  name: "IntegrationSettings",

  layout: [DashboardLayout, IntegrationLayout],

  mixins: [HandleSettings],

  components: {
    ValidationErrors,
    TwoIntegrations,
    Expander,
    FormInput,
    FormInputHeader,
    MappingTable,
    FormButton,
  },

  props: {
    user: Object
  },

  computed: {
    ...mapGetters('integrationDetails', ['integration1', 'integration2', 'flows', 'isAdmin']),

    integrationId() {
      return this.$route().params.integration;
    },

    prepareDataEndpoint() {
      return `/user/${this.user.id}/integrations/${this.integrationId}`;
    },

    saveSettingsEndpoint() {
      return `/integration-settings/${this.integrationId}`;
    },
  },
}
</script>
